<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <Header/>
        <b-container fluid>

            <b-row class="titulo">
                <b-col class="seccionTitulo">
                    <span class="fa fa-table"></span>
                    <span>Grupos</span>
                </b-col>
                <b-col class="seccionCodigo">
                    <div>C-00</div>
                </b-col>
            </b-row>

            <b-row>
                <b-col class="subtitulos">
                    Búsqueda de grupos
                </b-col>
            </b-row>

            <b-row>

                <b-col>
                    <b-row align-v="center" align-h="end">
                        <b-col>

                            <b-form-group align="left">
                                <label for="nombreBusq">Palabra clave</label>
                                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="menu-button-wide"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input name="nombre" placeholder="Nombre del grupo"
                                                  v-model="filtro.palabraClave" @keydown.enter.native="obtener"
                                    ></b-form-input>
                                </b-input-group>
                            </b-form-group>

                        </b-col>

                        <b-col></b-col>

                        <b-col align="center">
                            <b-button v-b-tooltip.hover title="Agregar grupo" variant="outline-success"
                                      @click="agregar()" v-if="$localStorageService.can('BO_03_alta_grupos')">Agregar grupo
                            </b-button>
                        </b-col>

                    </b-row>

                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12">
                    <b-table
                            id="Pendientes"
                            thead-tr-class="columnas"
                            :items="datosTabla"
                            :fields="fields"
                            :per-page="$registrosPorPaginaTabla"
                            :current-page="paginaActual"
                            responsive="true"
                            class="parrafos"
                            fixed>
                            <template v-slot:cell(fechaModificacion)="row">
                                {{ row.item.fechaModificacion | formatoFechaCorta }}
                            </template>
                        <template v-slot:cell(Acciones)="row">
                            <b-button-group>
                                <b-button v-if="$localStorageService.can('BO_03_modif_grupos')"
                                        title="Modificar grupo"
                                        size="sm"
                                        @click="modificar(row.item)"
                                        variant="outline-warning"
                                ><em class="fa fa-pencil"></em></b-button>
                                <b-button v-if="!row.item.registroActivo && $localStorageService.can('BO_03_activar_grupo')"
                                          title="Activar grupo"
                                          variant="outline-danger"
                                          size="sm"
                                          @click="activar(row.item)"
                                ><em class="fa fa-undo"></em></b-button>
                                <b-button v-else-if="$localStorageService.can('BO_03_baja_grupo')"
                                          title="Desactivar grupo"
                                          variant="outline-danger"
                                          size="sm"
                                          @click="desactivar(row.item)"
                                >
                                    <b-icon icon="trash-fill"></b-icon>
                                </b-button>
                            </b-button-group>

                        </template>
                    </b-table>
                    <div align="center" v-if="loader">
                        <b-spinner variant="primary" label="Spinning"></b-spinner>
                    </div>
                    <b-col v-if="!loader">
                        <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
                    </b-col>
                    <b-col v-if="!loader">
                        <b-pagination
                                v-if="datosTabla !== undefined && datosTabla.length > 10"
                                align="center"
                                v-model="paginaActual"
                                :total-rows="datosTabla.length"
                                :per-page="$registrosPorPaginaTabla"
                                aria-controls="my-table1"
                        ></b-pagination>
                    </b-col>
                </b-col>


            </b-row>

        </b-container>


        <b-modal
                v-model="show"
                :title="tituloModal"
                size="lg"
                scrollable
        >
            <b-form @submit.stop.prevent="guardar">
                <b-container fluid>
                    <b-row>
                        <b-col>
                            <b-form-group align="left">
                                <label for="nombre">Nombre
                                    <validacion />
                                </label>
                                <b-input-group size="sm" class="mb-2" id="nombre">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="menu-button-wide"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input name="nombre" placeholder="Nombre del grupo"
                                                  v-model="$v.grupo.nombreGrupo.$model"
                                                  :state="validateState('nombreGrupo')"
                                    ></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col>
                            <b-form-group label="Perfiles" label-for="idPerfiles">
                                <v-select style="width: 100%" :options="listaPerfiles" multiple
                                          v-model="$v.grupo.listaPerfilesIds.$model" :reduce="(variable) => variable.idPerfil" label="nombrePerfil"
                                          placeholder="Selecciona los perfiles (*)" id="idPerfiles">
                                    <span slot="no-options">No hay perfiles disponibles</span>
                                </v-select>
                            </b-form-group>
                        </b-col>

                        <b-col>
                            <b-form-group label="Canal" label-for="idSistema">
                                <v-select style="width: 100%" :options="listaCanalOrigen"
                                          v-model="$v.grupo.idSistema.$model" :reduce="(variable) => variable.idCanalOrigen" label="descripcion"
                                          placeholder="Selecciona el canal (*)" id="idSistema">
                                  <span slot="no-options">No hay perfiles disponibles</span>
                                </v-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-container>
                <b-button ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
            </b-form>

            <template v-slot:modal-footer>
                <b-button variant="outline-primary" @click="submitGuardar" :disabled="loaderAcciones" v-if="$localStorageService.can('BO_03_alta_grupos')">
                    <span v-if="!loaderAcciones">Guardar</span>
                    <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                        Cargando...
                    </span>
                </b-button>
                <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
            </template>

        </b-modal>
    </div>
</template>

<script>
    import Header from "../../components/Header";
    import {validationMixin} from "vuelidate";
    import {required} from "vuelidate/lib/validators";


    export default {
        name: "grupoIndex",
        components: {
            Header
        },
        mixins: [validationMixin],
        data: () => {
            return {
              version: process.env.VUE_APP_ENV_VERSION,
              debug: false,
                datosTabla: [],
                listaPerfiles: [],
                fields: [
                    {key: "idGrupo", label: "ID", sortable: true},
                    {key: "nombreGrupo", label: "Nombre", sortable: true},
                    {key: "listaPerfilesNombre", label: "Perfiles", sortable: false},
                    {key: "fechaModificacion", label: "Fecha modificación", sortable: true},
                    {key: "nombreUsuarioModificacion", label: "Usuario modificación", sortable: true},
                    "Acciones",
                ],
                paginaActual: 1,
                show: false,
                tituloModal: '',
                grupo: {
                    idGrupo: null,
                    nombreGrupo: null,
                    listaPerfilesIds: [],
                    idSistema: null
                },
                filtro: {
                    id: null,
                    palabraClave: null,
                    registroActivo: null
                },
                loaderAcciones: false,
                loader: false,
                listaCanalOrigen: []
            }
        },
        validations: {
            grupo: {
                nombreGrupo: {required},
                listaPerfilesIds: {},
                idSistema: {required}
            }
        },
        created() {
          this.debug = this.$localStorageService.getDebug();
            this.obtenerPerfiles();
            this.obtener();
            this.obtenerCanalesOrigen();
        },
        methods: {
            obtenerPerfiles() {
                this.loader = true;
                this.listaPerfiles = [];
                this.$http.post(this.$api + 'catalogos/perfil/listaPerfiles', {}).then(respuesta => {
                    this.listaPerfiles = respuesta.data.data;
                });
            },
            obtener() {
                this.loader = true;
                this.datosTabla = [];
                this.$http.post(this.$api + 'catalogos/grupos/obtenerGrupos', this.filtro).then(respuesta => {
                        if (respuesta.data.data) {
                            respuesta.data.data.forEach(it => {
                                this.paginaActual=1;
                                this.datosTabla.push(it);
                            })
                        }

                    }
                ).finally(() => {
                        this.loader = false;
                    }
                )
            },
            agregar() {
                this.$nextTick(() => {
                    this.$v.$reset()
                });
                this.grupo = {
                    idGrupo: null,
                    nombreGrupo: null,
                    listaPerfilesIds: [],
                    idSistema: []
                };
                this.tituloModal = 'Agregar grupo';
                this.show = true;
            },
            modificar(item) {
                this.$nextTick(() => {
                    this.$v.$reset()
                });
                this.grupo = JSON.parse(JSON.stringify(item));
                this.tituloModal = 'Modificar grupo';
                this.show = true;
            },
            submitGuardar() {
                this.$refs.submitGuardar.click();
            },
            guardar() {
                this.$v.grupo.$touch();
                if (this.$v.grupo.$anyError) {
                    return;
                }
                
                if (this.grupo.listaPerfilesIds.length == 0) {
                    this.$swal({
                        icon: "info",
                        title: "Aviso",
                        text: "Debe seleccionar al menos un perfil",
                    })
                    return false;
                }

                if (!this.$v.grupo.$invalid) {
                    this.loaderAcciones = true;
                    this.$http.post(this.$api + 'catalogos/grupos/guardar', this.grupo).then(respuesta => {
                            if (respuesta.data.data) {
                                this.$swal.fire({
                                    icon: "info",
                                    title: "Aviso",
                                    text: "El grupo se registró correctamente",
                                });
                                this.filtro.palabraClave = this.grupo.nombreGrupo;
                                this.obtener();
                                this.show = false;
                            }
                        }
                    ) .catch(error => {
                        console.error(error);
                        this.$swal.fire({
                            icon: "error",
                            title: "Aviso",
                            text: "El grupo ya existe",
                        });
                    }).finally(() => {
                            this.loaderAcciones = false;
                        }
                    )
                }
            },
            activar(item) {
                this.$swal({
                    icon: "warning",
                    text: "¿Está seguro de activar el grupo?",
                    confirmButtonText: 'Si',
                    cancelButtonText: 'No',
                    showCancelButton: true,
                    showConfirmButton: true,
                }).then((aceptar) => {
                    if (aceptar.value) {
                      const parametros = {
                        idGrupo: item.idGrupo,
                      };
                        this.$http.delete(this.$api + 'catalogos/grupos/reactivar', parametros).then(respuesta => {
                                if (respuesta.data.data) {
                                    this.datosTabla[this.datosTabla.indexOf(item)].registroActivo = true;
                                }
                            }
                        )
                    }
                })
            },
            desactivar(item) {
                this.$swal({
                    icon: "warning",
                    text: "¿Está seguro de desactivar el grupo?",
                    confirmButtonText: 'Si',
                    cancelButtonText: 'No',
                    showCancelButton: true,
                    showConfirmButton: true,
                }).then((aceptar) => {
                    if (aceptar.value) {
                      const parametros = {
                        idGrupo: item.idGrupo,
                      };
                        this.$http.post(this.$api + 'catalogos/grupos/desactivar', parametros).then(respuesta => {
                                if (respuesta.data.data) {
                                    this.datosTabla[this.datosTabla.indexOf(item)].registroActivo = false;
                                }
                            }
                        )
                    }
                })
            },
          obtenerCanalesOrigen() {
            this.loader = true;
            this.$http.get(this.$api + 'catalogos/obtenerCanalesOrigen').then(respuesta => {
                  if (respuesta.data.data) {
                    this.listaCanalOrigen = respuesta.data.data;
                    this.listaCanalOrigen = this.listaCanalOrigen.filter(e => e.idCanalOrigen === 1 || e.idCanalOrigen === 28)
                  }

                }
            ).finally(() => {
                  this.loader = false;
                }
            )
          },
            validateState(name) {
                const {$dirty, $error} = this.$v.grupo[name];
                return $dirty ? !$error : null;
            },
            cerrarModal() {
                this.show = false;
            }
        }
    }
</script>

<style scoped>

</style>
